import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { MotiveActionsProps } from './props';
import { useMotiveListActions } from './hook';

export const MotiveListActions = ({ name, active }: MotiveActionsProps) => {
    const { handleEdit } = useMotiveListActions(name, active);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
